import { useState } from 'react'

import { saveAnswer, type AskHave, type AskQuestion } from '../../api/auditAnswers'

/*
 * O intrebare pentru client, cu raspunsul ei.
 *
 * Sta intr-un fisier al ei fiindca o cer DOUA ecrane: chestionarul pe care il
 * primeste clientul, si cardul ariei din planul auditului - unde intrebarile
 * au fost aduse ca sa nu mai trebuiasca plecat de pe plan ca sa se vada daca
 * au fost completate. Doua copii ale aceluiasi formular s-ar fi despartit la
 * prima schimbare, si una din ele ar fi salvat altfel decat cealalta.
 */
/**
 * Alegerea se salveaza pe loc; nota se scrie cand omul pleaca
 * din camp, si numai daca exista deja o alegere - o nota fara raspuns n-are de
 * ce sa se lege.
 */
export function AskQuestionRow({
  area,
  q,
  have,
  onCoverage,
}: {
  area: string
  q: AskQuestion
  have: AskHave | null
  onCoverage: (answered: number) => void
}) {
  const [picked, setPicked] = useState(have ? String(have.value) : '')
  const [note, setNote] = useState(have ? have.note : '')
  const [when, setWhen] = useState<'kept' | 'saved' | 'failed'>('kept')
  const [said, setSaid] = useState('')

  const save = (value: string, noteNow: string) => {
    setSaid('')
    saveAnswer(area, q.key, value, noteNow)
      .then((r) => {
        if (!r.ok) {
          setPicked(have ? String(have.value) : '')
          setWhen('failed')
          setSaid(r.error)
          return
        }
        onCoverage(r.coverage.answered)
        setWhen('saved')
      })
      .catch(() => {
        setPicked(have ? String(have.value) : '')
        setWhen('failed')
        setSaid('That did not save.')
      })
  }

  return (
    <div className="od-ask-q" data-key={q.key}>
      <p className="od-ask-question">{q.question}</p>
      {q.help !== '' && <p className="od-ask-help">{q.help}</p>}
      <div className={`od-ask-options${q.kind === 'ladder' ? ' is-ladder' : ''}`}>
        {q.options.map((opt) => {
          const value = String(opt.value)
          return (
            <button
              key={value}
              type="button"
              className={`od-ask-opt${picked === value ? ' is-on' : ''}`}
              data-value={value}
              onClick={() => {
                setPicked(value)
                save(value, note)
              }}
            >
              {q.kind === 'ladder' && <span className="od-ask-n">{Number(opt.value)}</span>}
              <span className="od-ask-text">{opt.text}</span>
            </button>
          )
        })}
      </div>
      <input
        type="text"
        className="form-control input-sm od-ask-note"
        maxLength={2000}
        placeholder="Anything we should know? (optional)"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        onBlur={() => {
          if (picked !== '' && note !== (have?.note ?? '')) save(picked, note)
        }}
      />
      <p className={`od-ask-when${when === 'kept' && !have ? ' is-empty' : ''}`}>
        {when === 'saved' && 'Saved just now'}
        {when === 'failed' && <span className="od-ask-stale">{said}</span>}
        {when === 'kept' && have && (
          <>
            Answered {have.at}
            {have.who !== '' && <> by {have.who}</>}
            {have.stale && <span className="od-ask-stale"> — more than a year ago, worth confirming</span>}
          </>
        )}
      </p>
    </div>
  )
}
